<template>
  <div class="main-container">
    <News v-loading="loading" class="container newsInfo">
      <template v-slot:newsContent>
        <div class="breadcrumbBox">
        <span class="infoLocation"></span><Breadcrumb :breadTitle="list" :breadList="breadList"  :separator="separator" />
        </div>
        <el-row :gutter="20" class="content">
          <el-col :sm="24" v-if="list">
            <div class="rich-text-wrapper">
              <h1>{{ list.title }}</h1>
              <div class="info">
                发布时间：{{ timeFormat(list.createTime) }}
              </div>
              <NewsContent :newsInfo="list" />
              <div v-if="list.attachmentList&&list.attachmentList.length!=0">
              <p>附件</p>
               <div class="rich-box" v-for="(item,index) in list.attachmentList" :key="index">
                 <div class="attachitem"><i class="el-icon-document">{{item.title}}</i> <div class="item-right"><el-button type="primary" @click="download(item,buildResourcePath(item.url))">下载</el-button>{{sizeFormat(item.size)}}</div>
                </div>
               </div>
               </div>
            </div>
          </el-col>
        </el-row>
      </template>
      <template v-slot:rightMenu>
          <!-- <hotNews :title="title" :news="news" v-if="news&&title"/> -->
      </template>
    </News>
  </div>
</template>
<script>
import News from "@/components/news/News.vue";
// import hotNews from "@/components/news/hotNews.vue";
import { infomation,news} from "@/api/api.js";
import util from "@/libs/util.js";
import NewsContent from "@/components/news/news-Content";
import Breadcrumb from "@/components/breadcrumb";
import config from "../config.js";
export default {
  data() {
    return {
      list: null,
      id: null,
      loading: null,
      breadList: [],
      menu: null,
      news:null,
      title:null,
      menuId:null,
      separator:"/"
    };
  },
  components: {
    NewsContent,
    Breadcrumb,
    News,
    // hotNews
  },
  created() {
   this.init()
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init(){
      console.log(this.$route);
    this.menu = config.menuList;
    this.menuId=this.$route.params.menuId
    this.id = this.$route.params.id;
    this.getNews();
    this.getHotNews();
    },
    updataDate() {
      this.breadList = [];
       this.breadList.push({
        title: "首页",
        content: "../portal",
        icon: "iconyemiandaohang-shouye",
      });
      this.getMenuByRoute();
      this.breadList.push({
        title: "文章详情",
        content: "",
        icon: "",
      });
    },
    getNews() {
      this.loading = true;
      infomation(this.id)
        .then((res) => {
          // 返回数据
          this.list = res.result;
          this.loading = false;
          this.updataDate();
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    getHotNews() {
      news({
        relationType:1,
        relationId: config.relationId,
        menuId: this.menuId,
        ps: 4,
        pn: 1
      })
        .then(res => {
          // 返回数据
          this.news = res.list;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });
    },
    download(item,src){
    src=src+'?attname='+item.title
    window.open(src)
    },
    buildResourcePath(src) {
      return util.buildResourcePath(src)
    },
    sizeFormat(size){
      return util.sizeFormat(size)
    },
    getMenuByRoute() {
     if(this.menuId==1970){
        this.breadList.push({
        title: "首页",
        content: "../../portal",
        icon: "",
      });
      }
      //根据路由判断左侧菜单的当前激活
      for (var i = 0; i < this.menu.length; i++) {
        var menu = this.menu[i];
        if (menu.isActive(this.$route)) {
          this.breadList.push(menu);
          this.title=menu.title
          return;
        }
        for (var j = 0; j < menu.subMenuList.length; j++) {
          var subMenu = menu.subMenuList[j];
          if (subMenu.isActive(this.$route)) {
            // this.breadList.push(menu);
            this.breadList.push(subMenu);
            this.title=menu.title
            return;
          }
          if (subMenu.subMenuList) {
            for (var z = 0; z < subMenu.subMenuList.length; z++) {
              var lastMenu = subMenu.subMenuList[z];
              if (lastMenu.isActive(this.$route)) {
                this.breadList.push(menu);
                this.breadList.push(subMenu);
                this.breadList.push(lastMenu);
                this.title=menu.title
                return;
              }
            }
          }
        }
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
  },
};
</script>
<style lang="scss" scoped>
.rich-box{
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}
.attachitem{
  width: 100%;
  float: left;
  margin-bottom: 10px;
}
p{
  margin-top: 20px;
}
.attachitem i{
  line-height: 40px;
  padding-left: 10px;
}
.attachitem .item-right{
 float:right;
}
.attachitem:hover{
  background-color: #cccccc;
  cursor: pointer;
}
.el-button{
  margin-right: 10px;
}
.main-container{
   background-color: #f7f7fe;
}
.newsInfo {
  min-height: 100%;
  padding-top: 20px;
}
.content {
  margin-top: 20px;
  padding: 20px 30px;
  background-color: #fff;
  margin-bottom: 80px;
  border: 1px solid #efeff7;
}
.rich-text-wrapper h1 {
  font-size: 22px;
  line-height: 32px;
}

.rich-text-wrapper .info {
  margin: 20px 0;
  font-size: 12px;
  line-height: 16px;
  color: #888;
}
.infoLocation {
  float: left;
  font-size: 14px;
  line-height: 19px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .breadcrumbBox{
    padding-left: 20px;
    padding-top: 20px;
  
  }
  .container{
    padding: 0px;
  }
  .content{
    margin-top:0px;
    margin-bottom:20px;
    padding: 20px 20px 0px;
    border: none;
  }
  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
}
</style>